import client from "./_client";

const endpointV1 = `/v1/history`;

export const getUserWatchHistory = () => client.get(endpointV1 + "/");
